import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import './style.css';

const useStyles = makeStyles(theme => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
      },
    },
  }));


const ZoneCard = ({ data, index, style }) => {
    const { zones, onClick, mode = "add" } = data;
    const classes = useStyles();
    const zone = zones[index]

    return (
        <div className={`zone-card-wrapper ${classes.root}`} key={zone._id} style={style}>
            <p>{zone.name}</p>
            <Button onClick={() => onClick(zone._id)}>
                { mode === 'add' ? <AddIcon color="primary"/> : <RemoveIcon color="secondary" /> }
            </Button>
        </div>
    )
}

export default ZoneCard